<ng-container *appTranslate="let t">
  <new-ui-error-page
    errorCode="Err://"
    [errorMessage]="t('errorOccured.title')"
    [errorDescription]="t('errorOccured.message')"
    [isError]="true"
  >
    <a pButton severity="danger" [text]="true" [routerLink]="['/']">{{ t("home.title") }}</a>
  </new-ui-error-page>
</ng-container>
